import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Config } from "../config";
import { useThemeProvider } from '../utils/ThemeContext';
import Toast2 from '../components/Toast2';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { attribs } = useThemeProvider();
  const [toastErrorOpen, setToastErrorOpen] = useState(false);
  const [toastErrorMsg, setToastErrorMsg] = useState('');
  const [toastSuccessOpen, setToastSuccessOpen] = useState(false);
  const [toastSuccessMsg, setToastSuccessMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setStatus({
        type: 'error',
        message: 'Please enter your email address'
      });
      return;
    }
    
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });
    
    try {
      await axios.post(
        `${Config.APIBaseURL}/auth/forgot-password`,
        { email },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      
      setToastSuccessOpen(true);
      setToastSuccessMsg('If an account with that email exists, we have sent password reset instructions.');
      
    } catch (error) {
      setToastErrorOpen(true);
      setToastErrorMsg('There was a problem processing your request. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`min-h-screen bg-gray-${attribs.bg} flex flex-col justify-center py-12 sm:px-6 lg:px-8`}>
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex flex-col items-center justify-center">
          <img
            className="max-w-xs mx-auto"
            src={attribs.logo}
            alt="Your Company"
          />
          <p className={`mt-2 text-center text-sm text-gray-${attribs.txtgray} w-full`}>
            Enter your email for instructions to reset your password
          </p>
        </div>
      </div>

      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className={`bg-${attribs.cardBg} py-8 px-4 shadow sm:rounded-lg sm:px-10`}>
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              {toastErrorOpen && (
                <h2 className="text-center text-sm text-gray-600 mb-2">
                    {<Toast2 type="error" open={toastErrorOpen} setOpen={setToastErrorOpen}>{toastErrorMsg}</Toast2>}
                </h2>
              )}  
              {toastSuccessOpen && (
                <h2 className="text-center text-sm text-gray-600 mb-2">
                  {<Toast2 open={toastSuccessOpen} setOpen={setToastSuccessOpen}>{toastSuccessMsg}</Toast2>}
                </h2>
              )}
              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  className={`appearance-none block w-full px-3 py-2 border border-gray-${attribs.borderform} rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-gray-500`}
                />
              </div>
            </div>
            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${
                  isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                }`}
              >
                {isSubmitting ? 'Sending...' : 'Send Reset Instructions'}
              </button>
            </div>
          </form>

          <div className="mt-6">
            <div className="mt-6 text-center">
              <Link 
                to="/login" 
                className="text-sm text-indigo-500 hover:text-indigo-400"
              >
                Back to login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 